import React, { useState, useEffect } from "react";
import { Layout, Popover, Divider, Button, message } from "antd";
import { Link, useHistory, useLocation } from "react-router-dom";
import CustomScrollbars from "util/CustomScrollbars";
import languageData from "./languageData";
import { switchLanguage, toggleCollapsedSideNav } from "../../appRedux/actions";
import SearchBox from "../../components/SearchBox";
import UserInfo from "../../components/UserInfo";
import AppNotification from "../../components/AppNotification";
import MailNotification from "../../components/MailNotification";
import Auxiliary from "util/Auxiliary";
import UserProfile from "./UserProfile";

import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";

const { Header } = Layout;

const Topbar = () => {
  const { locale, navStyle } = useSelector(({ settings }) => settings);
  const navCollapsed = useSelector(({ common }) => common.navCollapsed);
  const width = useSelector(({ common }) => common.width);
  const [searchText, setSearchText] = useState('');
  const [mouseEvent, setMouseEvent] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const languageMenu = () => (
    <CustomScrollbars className="gx-popover-lang-scroll">
      <ul className="gx-sub-popover">
        {languageData.map(language =>
          <li className="gx-media gx-pointer" key={JSON.stringify(language)} onClick={() =>
            dispatch(switchLanguage(language))
          }>
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
            <span className="gx-language-text">{language.name}</span>
          </li>
        )}
      </ul>
    </CustomScrollbars>);

  const onChange = (evt) => {
    setSearchText(evt.target.value);
  };

  const onKeyDown = (evt) => {
    var evt = evt || window.event
    if (evt.keyCode == "13") {
      quickSearch();
    }
  };

  const onSearch = () => {
    quickSearch();
  };

  const quickSearch = () => {
    if (searchText.length >= 3) {
      history.push('/jobs?keyword=' + searchText);
    } else {
      message.info('Please enter 3 characters or more for quick search.');
    }
  };

  useEffect(() => {
    if (history.location.pathname === '/jobs' && history.location.search.indexOf('keyword') >= 0) {
      const urlParams = new URLSearchParams(history.location.search);
      let keyword = urlParams.get('keyword');
      setSearchText(keyword);
    } else {
      setSearchText('');
    }
  }, [location]);

  return (
    <>
      <Header>
        {navStyle === NAV_STYLE_DRAWER || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ?
          <div className="gx-linebar gx-mr-3">
            <i className="gx-icon-btn icon icon-menu"
              onClick={() => {
                dispatch(toggleCollapsedSideNav(!navCollapsed));
              }}
            />
          </div> : null}
        <Link to="/jobs" className="gx-d-block gx-d-lg-none gx-pointer">
          <img alt="" src={("/assets/images/w-logo.png")} /></Link>
        <SearchBox styleName="gx-d-none gx-d-lg-block gx-lt-icon-search-bar-lg"
          placeholder="Quick Search"
          onChange={onChange}
          onKeyDown={onKeyDown}
          onSearch={onSearch}
          value={searchText} />
        <ul className="gx-header-notifications gx-ml-auto">
          <UserProfile />
        </ul>
      </Header>
    </>

  );
};

export default Topbar;
